import { supabase } from '../lib/supabase';
import { retryWithBackoff } from '../utils/retryWithBackoff';

export const getUserProfile = async (userId) => {
  if (!supabase) {
    throw new Error('Database unavailable');
  }

  return retryWithBackoff(async () => {
    const { data, error } = await supabase?.from('user_profiles')?.select('*')?.eq('id', userId)?.single();

    if (error) throw error;
    return data;
  });
};

export const updateUserProfile = async (userId, updates) => {
  if (!supabase) {
    throw new Error('Database unavailable');
  }

  return retryWithBackoff(async () => {
    const { data, error } = await supabase?.from('user_profiles')?.update(updates)?.eq('id', userId)?.select()?.single();

    if (error) throw error;
    return data;
  });
};

export const createUserProfile = async (profileData) => {
  if (!supabase) {
    throw new Error('Database unavailable');
  }

  return retryWithBackoff(async () => {
    const { data, error } = await supabase?.from('user_profiles')?.insert([profileData])?.select()?.single();

    if (error) throw error;
    return data;
  });
};

export const getContractorProfile = async (userId) => {
  if (!supabase) {
    throw new Error('Database unavailable');
  }

  return retryWithBackoff(async () => {
    const { data, error } = await supabase?.from('contractor_profiles')?.select('*')?.eq('user_id', userId)?.single();

    if (error) throw error;
    return data;
  });
};

export const updateContractorProfile = async (userId, updates) => {
  if (!supabase) {
    throw new Error('Database unavailable');
  }

  return retryWithBackoff(async () => {
    const { data, error } = await supabase?.from('contractor_profiles')?.update(updates)?.eq('user_id', userId)?.select()?.single();

    if (error) throw error;
    return data;
  });
};

export const createContractorProfile = async (profileData) => {
  if (!supabase) {
    throw new Error('Database unavailable');
  }

  return retryWithBackoff(async () => {
    const { data, error } = await supabase?.from('contractor_profiles')?.insert([profileData])?.select()?.single();

    if (error) throw error;
    return data;
  });
};

export const getClientProfile = async (userId) => {
  if (!supabase) {
    throw new Error('Database unavailable');
  }

  return retryWithBackoff(async () => {
    const { data, error } = await supabase?.from('client_profiles')?.select('*')?.eq('user_id', userId)?.single();

    if (error) throw error;
    return data;
  });
};

export const updateClientProfile = async (userId, updates) => {
  if (!supabase) {
    throw new Error('Database unavailable');
  }

  return retryWithBackoff(async () => {
    const { data, error } = await supabase?.from('client_profiles')?.update(updates)?.eq('user_id', userId)?.select()?.single();

    if (error) throw error;
    return data;
  });
};

export const createClientProfile = async (profileData) => {
  if (!supabase) {
    throw new Error('Database unavailable');
  }

  return retryWithBackoff(async () => {
    const { data, error } = await supabase?.from('client_profiles')?.insert([profileData])?.select()?.single();

    if (error) throw error;
    return data;
  });
};

export const getAffiliateProfile = async (userId) => {
  if (!supabase) {
    throw new Error('Database unavailable');
  }

  return retryWithBackoff(async () => {
    const { data, error } = await supabase?.from('affiliate_profiles')?.select('*')?.eq('user_id', userId)?.single();

    if (error) throw error;
    return data;
  });
};

export const updateAffiliateProfile = async (userId, updates) => {
  if (!supabase) {
    throw new Error('Database unavailable');
  }

  return retryWithBackoff(async () => {
    const { data, error } = await supabase?.from('affiliate_profiles')?.update(updates)?.eq('user_id', userId)?.select()?.single();

    if (error) throw error;
    return data;
  });
};

export const createAffiliateProfile = async (profileData) => {
  if (!supabase) {
    throw new Error('Database unavailable');
  }

  return retryWithBackoff(async () => {
    const { data, error } = await supabase?.from('affiliate_profiles')?.insert([profileData])?.select()?.single();

    if (error) throw error;
    return data;
  });
};
function profileService(...args) {
  // eslint-disable-next-line no-console
  console.warn('Placeholder: profileService is not implemented yet.', args);
  return null;
}

export default profileService;